// import { AUTO_SCHEDULING_ERROR_EMAILS } from '../../protected/extensions/constants';

const innerObject = {
  COMMON_USER_PHOTO: 'https://ganttprowe.blob.core.windows.net/app/imgs/common_user_avatar.svg',
  DEFAULT_PROJECT_TYPE: 'team',
  STATUS_DEFAULT: 1,
  PRIORITY_DEFAULT: 7,
  TASK_DATES_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  MIN_PASSWORD_LENGTH: 8,
  MIN_USER_SCORING_PERCENT_FOR_DEMO_SCHEDULE: 64,
  TIME_FOR_SHOWING_DEMO_POPUP_SECOND_TIME: 604800000, // 604800000 - 7days

  JOB_TITLES: [
    { c_level: 'job_option_partner' },
    { group_manager: 'job_option_head_of' },
    { manager: 'job_option_manager' },
    { project_manager: 'job_option_pm' },
    { student: 'job_option_student' },
    { educator: 'job_option_educator' },
    { other: 'job_option_other' },
  ],

  JOB_FIELDS: [
    { marketing: 'app_welcome_form_job_field_option_marketing' },
    { engineering: 'app_welcome_form_job_field_option_engineering' },
    { development: 'app_welcome_form_job_field_option_development' },
    { accounting: 'app_welcome_form_job_field_option_accounting' },
    { hr: 'app_welcome_form_job_field_option_hr' },
    { other: 'app_welcome_form_job_field_option_other' },
  ],
  TOOL_USED_BEFORE: [

    { excel_or_google_sheet: 'app_welcome_form_tool_used_before_excel_or_google_sheet' },
    { ms_project: 'app_welcome_form_tool_used_before_ms_project' },
    { jira_or_analogs: 'app_welcome_form_tool_used_before_jira_or_analogs' },
    { other_gantt_software: 'app_welcome_form_tool_used_before_other_gantt_software' },
    { other_pm_software: 'app_welcome_form_tool_used_before_other_pm_software' },
    { no_tool: 'app_welcome_form_tool_used_before_no_tool' },
    { student: 'app_welcome_form_tool_used_before_student' },
    { other: 'app_welcome_form_tool_used_before_other' },
  ],

  TEAM_SIZES: [
    { 1: 'app_welcome_industry_btn_one' },
    { 4: '2-4' },
    { 20: '5-20' },
    { 50: '21-50' },
    { 200: '51-200' },
    { 500: '201+' },
  ],
  INDUSTRIES: [
    { construction: 'onboarding_industry_construction' },
    { manufacturing: 'onboarding_industry_manufacturing' },
    { tech_engineering: 'onboarding_industry_tech_engineering' },
    { consulting: 'onboarding_industry_consulting' },
    { marketing_digital: 'onboarding_industry_marketing_digital' },
    { public_nonprofit: 'onboarding_industry_public_nonprofit' },
    { it_software: 'onboarding_industry_it_software' },
    { healthcare: 'onboarding_industry_healthcare' },
    { finance: 'onboarding_industry_finance' },
    { other: 'onboarding_industry_other' },
  ],
  NOTIFICATION_ACTIONS: {
    MENTION: 1,
    ASSIGN: 2,
    COMMENT: 3,
    ATTACHMENT: 4,
    FEATURES: 5,
    PROMO: 6,
    WELCOME: 7,
    START_TASK: 8,
    DEADLINE: 9,
    EMAIL: 10,
    INVITE_TO_TEAM: 11,
    END_TASK: 12,
  },
  TASK_TYPES: {
    project: 'project',
    task: 'task',
    milestone: 'milestone',
    button: 'button',
  },
  TASK_STATUSES: {
    1: {
      color: '#9b9b9b',
      locale: 'filter_status_open',
    },
    2: {
      color: '#ff9921',
      locale: 'filter_status_in_progress',
    },
    3: {
      color: '#55BED4',
      locale: 'filter_status_done',
    },
    4: {
      color: '#14bb4c',
      locale: 'filter_status_closed',
    },
  },
  STATUSES: [
    {
      id: '1',
      color: '#9b9b9b',
      locale: 'filter_status_open',
    },
    {
      id: '2',
      color: '#ff9921',
      locale: 'filter_status_in_progress',
    },
    {
      id: '3',
      color: '#55BED4',
      locale: 'filter_status_done',
    },
    {
      id: '4',
      color: '#14bb4c',
      locale: 'filter_status_closed',
    },
  ],
  PRIORITIES: [
    {
      id: '5',
      iconUrl: 'https://cdn.ganttpro.com/app/imgs/highest.svg',
      locale: 'filter_priority_highest',
    },
    {
      id: '6',
      iconUrl: 'https://cdn.ganttpro.com/app/imgs/high.svg',
      locale: 'filter_priority_high',
    },
    {
      id: '7',
      iconUrl: 'https://cdn.ganttpro.com/app/imgs/medium.svg',
      locale: 'filter_priority_medium',
    },
    {
      id: '8',
      iconUrl: 'https://cdn.ganttpro.com/app/imgs/low.svg',
      locale: 'filter_priority_low',
    },
    {
      id: '9',
      iconUrl: 'https://cdn.ganttpro.com/app/imgs/lowest.svg',
      locale: 'filter_priority_lowest',
    },
  ],
  ROLES: {
    OWNER: 1,
    ADMIN: 4,
    MEMBER: 3,
  },

  MAINTENANCE_NOTIFY: [
    { id: 'new_release_planned', value: 'New release planned' },
    { id: 'api_changes_are_coming', value: 'API changes are coming' },
    { id: 'temporary_performance_issues', value: 'Temporary performance issues' },
    { id: 'technical_issues', value: 'Technical issues' },
    { id: 'currently_experiencing_technical_difficulties', value: 'Currently experiencing technical difficulties' },
  ],

  RESOURCE_TIME_TYPE: 1,
  RESOURCE_ITEM_TYPE: 2,
  RESOURCE_COST_TYPE: 3,
  RESOURCE_TYPE_LOCALE: {
    1: 'resources_default_price_label_per_hour',
    2: 'resource_item_type_select',
    3: 'resource_cost_type_select',
  },
  COMMON_EMPTY_RESOURCE: 'notAssigned',
  COMMON_EMPTY_RESOURCE_ACTION: 'unassigned_action',
  COMMON_EMPTY: 'empty',
  ADMIN_PANEL: {
    DATE_FORMAT: 'YYYY-MM-DD HH:mm',
  },
  CALENDARS: {
    DATE_FORMAT: 'YYYY/MM/DD',
    LAYOUT_TYPES: {
      RESOURCE_CALENDAR: 'Resource',
      PROJECT_CALENDAR: 'Main',
      TEMPLATE_CALENDAR: 'Templates',
    },
    DAY_TYPES: {
      WEEKEND: 'weekend',
      CUSTOM: 'custom',
      WORKDAY: 'normal',
    },
  },
  PLANS: {
    FREE: 0,
    FOREVER_FREE: 1,
    ESSENTIAL: 2,
    TEAM_5: 4,
    TEAM_10: 5,
    TEAM_15: 6,
    TEAM_25: 6,
    TEAM_TRIAL: 12,
    GANTT_PRO: 13,
    BASE: 14,
    PRO: 15,
    BUSINESS: 16,
    ENTERPRISE_TEAM: 17,
    ENTERPRISE: 18,
  },
  ZOOM: {
    modeToZoomValue: {
      hour: 0, day: 1, week: 2, month: 3, quarter: 4, year: 5,
    },
    zoomValueToMode: ['hour', 'day', 'week', 'month', 'quarter', 'year'],
  },
  TEMPLATES_CATEGORIES: {
    construction: 'construction_templates_category',
    software_development: 'software_development_templates_category',
    services: 'services_templates_category',
    marketing: 'marketing_templates_category',
    consulting: 'consulting_templates_category',
    event_planning: 'event_planning_templates_category',
    web_design: 'web_design_templates_category',
    product_launch: 'product_launch_templates_category',
    retail: 'retail_templates_category',
    learning: 'learning_templates_category',
    methodology: 'methodology_templates_category',
    roadmap: 'roadmap_templates_category',
    planner: 'planner_templates_category',
    manufacturing: 'manufacturing_templates_category',
  },
  DURATION_LIMITS: {
    minute: 540000,
    hour: 9000,
    day: 3000,
    week: 600,
    month: 150,
  },
  CUSTOM_COLUMNS_TYPES: {
    select: {
      id: 1,
      locale: 'custom_columns_option_type_select',
    },
    text: {
      id: 2,
      locale: 'custom_columns_option_type_text',
    },
    number: {
      id: 3,
      locale: 'custom_columns_option_type_number',
    },
    date: {
      id: 4,
      locale: 'custom_columns_option_type_date',
    },
    checkbox: {
      id: 5,
      locale: 'custom_columns_option_type_checkbox',
    },
    color: {
      id: 6,
      locale: 'custom_columns_option_type_color',
    },
    multiselect: {
      id: 7,
      locale: 'custom_columns_option_type_multiselect',
    },
    resources: {
      id: 8,
      locale: 'custom_columns_option_type_resources',
    },
    tags: {
      id: 9,
      locale: 'custom_columns_option_type_tags',
    },
  },
  CUSTOM_COLUMNS_SUBTYPES: {
    sum: {
      id: 1,
      locale: 'custom_columns_option_aggregation_sum',
    },
    average: {
      id: 2,
      locale: 'custom_columns_option_aggregation_average',
    },
  },
  PALETTE_CONFIG: {},
  COLORS: {},
  DARKEN_COLORS: {},
  LIGHT_COLORS: {},
  TITLE_COLORS: {},
  SKINS: {
    1: {
      class: 'first-skin',
      locale: 'skins_horizontal_borders',
    },
    2: {
      class: 'second-skin',
      locale: 'skins_no_borders',
    },
    3: {
      class: 'third-skin',
      locale: 'skins_vertical_borders',
    },
    4: {
      class: 'fourth-skin',
      locale: 'skins_all_borders',
    },
  },
  // getColorsById,
  DEFAULT_TYPE_COLORS: {
    TASK: 1,
    GROUP: 10,
    PROJECT: 12,
    MILESTONE: 16,
    ESTIMATION: 18,
  },
  COLUMN_ORDER: {
    NOT_DRAGABLE: ['masschange', 'overdue', 'overload', 'comments', 'attachments', 'wbs', 'text', 'buttons', 'workload_resource_name'],
    NOT_MOVABLE_AFTER: ['masschange', 'overdue', 'overload', 'comments', 'attachments', 'wbs', 'text', 'buttons'],
    NOT_DROPABLE_BEFORE: ['masschange', 'overdue', 'overload', 'comments', 'attachments', 'wbs', 'text', 'buttons'],
    ALWAYS_FIXED_START: ['masschange', 'overdue', 'overload', 'comments', 'attachments', 'wbs', 'text'],
    ALWAYS_FIXED_END: ['buttons'],
    NOT_HIDABLE: ['text', 'overdue', 'overload', 'wbs', 'comments', 'attachments', 'masschange', 'workload_resource_name', 'buttons'],
  },
  FILTER_TYPES: {
    PROJECT: 'project',
    MULTIVIEW: 'multiview',
    WORKLOAD: 'workload',
    TASKSLIST: 'listView',
    TIMELOGS: 'timeloglist',
    COSTSFILTER: 'costslist',
  },
  GANTT_BASE_COLUMNS: {
    TASK_NAME: 'text',
    //
  },
  PRICING_FEATURES: {
    portfolio_view: {
      title: false,
      gif: true,
    },
    bulk_change: {
      title: true,
      gif: true,
    },
    overdue_tasks: {
      title: true,
      gif: true,
    },
    custom_fields: {
      title: false,
      gif: false,
    },
    cascade_sorting: {
      title: true,
      gif: true,
    },
    saving_project_templates: {
      title: false,
      gif: true,
    },
    saving_filters: {
      title: true,
      gif: true,
    },
    costs: {
      title: true,
      gif: false,
    },
    estimation: {
      title: false,
      gif: false,
    },
    estimation_assign: {
      title: true,
      gif: false,
    },
    time_tracking: {
      title: true,
      gif: true,
    },
    time_log: {
      title: false,
      gif: true,
    },
    workload: {
      title: false,
      gif: false,
    },
    workload_estimation: {
      title: false,
      gif: false,
    },
    workload_estimation_duration: {
      title: false,
      gif: false,
    },
    jira_cloud: {
      title: false,
      gif: false,
    },
    personal_calendar: {
      title: true,
      gif: false,
    },
  },
  USER_ACTIVITIES: {
    HELP_ONBOARDING: 'onboardingHelpBlock', // "onboarding"
    HELP_CREATE_ACOUNT: 'createAccountHelpBlock', // "create account"
    HELP_CUSTOM_GRID: 'customGridHelpBlock', // "columns"
    HELP_FILTER_VIEW: 'filterViewHelpPopup', // "filter"
    HELP_PROJ_SETTINGS: 'settingsHelpBlock', // "project settings"
    HELP_HISTORY: 'historyHelpPopup', // "history"
    HELP_BASELINE: 'baselineHeaderHelpBlock', // "baseline"
    HELP_PUBLIC_LINK: 'publicLinkHelpBlock', // "public link"
    HELP_USER_TEMPLATES: 'saveUserTemplateHelpBlock', // "templates"
    HELP_MANAGE_TEAM: 'manageTeamLayoutHelpPopup', // "team" in team and resources
    HELP_MANAGE_RES: 'resourcesLayoutHelpPopup', // "resources" in team and resources
    HELP_TASK_COST: 'taskCostHelpBlock', // "task cost"
    HELP_NOTIFICATIONS: 'userNotificationHelpBlock', // "notifications"
    HELP_WORKLOAD: 'workloadHelpBlock', // "resource workload"
    HELP_PROJ_IMPORT: 'importProjectBlock', // "project import"
    HELP_PROJ_CREATE: 'newProjectBlock', // "project creation"
    HELP_GOOGLE_DRIVE: 'googleDriveCreateDontShow', // "google drive create document checkbox"
    HELP_POPUP_ESP_LOCALE: 'espPopupCreateDontShow', // "popup for spanish locale"
    HELP_NPS_POPUP: 'npsPopup', // "NPS popup"
    HELP_EXPORT: 'toolBarExportHelpBlock', // "export"
    DEMO_POPUP: 'demoModalPopup', // "demo popup"
    SECOND_DEMO_POPUP: 'secondDemoModalPopup', // "second demo popup"
    LAST_NEWS_ID: 'lastViewedNewsEntryId', // last read news entry id
    PAYMENT: 'paymentWindow', // "pricing window"
    ONBOARDING: 'onboarding', // "onboarding"
    WORKLOAD: 'workload',
    MSTRECONNECT: 'msTeamsReconnect',
    CONVERSION_FEATURE_NOTIFICATION: 'conversionFeatureNotification',
    COMMENTS_FILTERED_TAB: 'commentsFilteredTab',
    COMMENTS_SELECTED_PROJECTS: 'commentsSelectedProjects',
    BASELINES: 'baselines',
  },
  WORKLOAD_PANEL_MIN_HEIGHT: 90,
  WORKLOAD_PANEL_DEFAULT_HEIGHT: 200,
  WORKLOAD_TYPES: {
    panel: 'panel',
    tab: 'tab',
    global: 'global',
  },
  WORKLOAD_VIEW_MODES: {
    hours: 'hours',
    tasks: 'tasks',
    percents: 'percents',
  },
  WORKLOAD_CALCULATION_MODES: {
    fixEstimation: 1,
    fixDuration: 2,
    fixEstimationAndDuration: 3,
  },
  GANTT_LINK_TYPES: {
    finish_to_start: '0',
    start_to_start: '1',
    finish_to_finish: '2',
    start_to_finish: '3',
  },
  ATTACHMENT_TYPE_KEYS: {
    FILE: 1,
    GOOGLE_DRIVE: 2,
    ONE_DRIVE: 3,
  },
  PROJECT_ROLES_DEFAULT: {
    owner: 'OWNER',
    admin: 'ADMIN',
  },
  OVERVIEW_TYPES: {
    ACTUAL_TO_PLANNED: 'actual_to_planned',
    ACTUAL_TO_BASELINE: 'actual_to_baseline',
    PLANNED_TO_BASELINE: 'planned_to_baseline',
  },
  TOAST_CONFIG: {
    position: 'top-right',
    timeout: 2500,
    hideProgressBar: true,
    closeButton: 'button',
    icon: true,
    draggable: false,
    closeOnClick: true,
  },
  PROGRESS_BAR: {
    STATUS: {
      STARTED: 1,
      UPDATE: 2,
      DONE: 3,
      FAIL: 4,
    },
    TIMEOUT: 4000,
  },
  BOARD_FIELD: {
    status: {
      locale: 'board_field_status',
      icon: {
        name: 'status-1',
        type: 'regular',
        size: 24,
      },
    },
    priority: {
      locale: 'board_field_priority',
      icon: {
        name: 'priority',
        type: 'regular',
        size: 24,
      },
    },
    name: {
      locale: 'board_field_name',
      icon: {
        name: 'task',
        type: 'regular',
        size: 24,
      },
    },
    wbs: {
      locale: 'board_field_wbs',
      icon: {
        name: 'left-list',
        type: 'regular',
        size: 24,
      },
    },
    resources: {
      locale: 'board_field_resources',
      icon: {
        name: 'user',
        type: 'regular',
        size: 24,
      },
    },
    createDate: {
      locale: 'board_field_create_date',
      icon: {
        name: 'calendar',
        type: 'regular',
        size: 24,
      },
    },
    startDate: {
      locale: 'board_field_start_date',
      icon: {
        name: 'startDate',
        type: 'regular',
        size: 24,
      },
    },
    endDate: {
      locale: 'board_field_end_date',
      icon: {
        name: 'endDate',
        type: 'regular',
        size: 24,
      },
    },
    tags: {
      locale: 'custom_columns_option_type_tags',
      icon: {
        name: 'label',
        type: 'regular',
        size: 24,
      },
    },
    select: {
      locale: 'custom_columns_option_type_select',
      icon: {
        name: 'list',
        type: 'regular',
        size: 24,
      },
    },
    color: {
      locale: 'custom_columns_option_type_color',
      icon: {
        name: 'color-backgroud',
        type: 'regular',
        size: 24,
      },
    },
    multiselect: {
      locale: 'custom_columns_option_type_multiselect',
      icon: {
        name: 'multiselect',
        type: 'regular',
        size: 24,
      },
    },
    resourcesCustom: {
      locale: 'custom_columns_option_type_resources',
      icon: {
        name: 'team',
        type: 'regular',
        size: 24,
      },
    },
  },
  BOARD_COLORS: {
    header: {
      status_open: '#E5E5E5',
      status_in_process: '#FFEBCC',
      status_done: '#CFECFC',
      status_closed: '#DDEDDB',
      priority_lowest: '#F2F2F2',
      priority_low: '#E5E5E5',
      priority_medium: '#DDEDDB',
      priority_high: '#FFEBCC',
      priority_highest: '#F8D7D7',
    },
  },
  BOARD: {
    COLORS: {
      status_open: {
        header: '#E5E5E5',
        dropdown: '#999999',
      },
      status_in_process: {
        header: '#FFEBCC',
        dropdown: '#FF9A00',
      },
      status_done: {
        header: '#CFECFC',
        dropdown: '#4FC3F7',
      },
      status_closed: {
        header: '#DDEDDB',
        dropdown: '#81C784',
      },
      priority_lowest: {
        header: '#F2F2F2',
        dropdown: '#CCCCCC',
      },
      priority_low: {
        header: '#E5E5E5',
        dropdown: '#999999',
      },
      priority_medium: {
        header: '#DDEDDB',
        dropdown: '#81C784',
      },
      priority_high: {
        header: '#FFEBCC',
        dropdown: '#FF9A00',
      },
      priority_highest: {
        header: '#F8D7D7',
        dropdown: '#DD3636',
      },
    },
    ICONS: {
      status_open: 'status-2',
      status_in_process: 'status-2',
      status_done: 'status-2',
      status_closed: 'status-2',
      priority_lowest: 'priority-2',
      priority_low: 'priority-2',
      priority_medium: 'priority',
      priority_high: 'priority',
      priority_highest: 'priority',
    },
  },
  GANTT_SOURCE_EVENT_TYPES: {
    TASK_CREATE: 'task_create',
    TASK_UPDATE: 'task_update',
    TASK_DELETE: 'task_delete',
    TASK_MOVE: 'task_move',
    PROJECT_TASK_MOVE: 'project_task_move',
    LINK_CREATE: 'link_create',
    LINK_UPDATE: 'link_update',
    LINK_DELETE: 'link_delete',
    CUSTOM_FIELDS_UPDATE: 'custom_fields_update',
    TASK_RESOURCES_UPDATE: 'task_resources_update',
    TASK_PREDECESSOR_UPDATE: 'task_predecessor_update',
    MASS_CHANGE: 'mass_change',
    CASCADE_SORT: 'cascade_sort',
    EXPAND_COLLAPSE_ALL: 'expand_collapse_all',
    RESOURCE_CALENDAR_UPDATE: 'resource_calendar_update',
    PROJECT_CALENDAR_UPDATE: 'project_calendar_update',
    PROJECT_PROGRESS_TYPE_UPDATE: 'project_progress_type_update',
    RESOURCE_REMOVE: 'resource_remove',
    RESOURCE_FROM_PROJECT_UNASSIGN: 'resource_from_project_unassign',
    RESOURCE_TYPE_UPDATE: 'resource_type_update',
    AUTO_SCHEDULING: 'auto_scheduling',
    WORKLOAD_CUSTOM_ESTIMATION_UPDATE: 'workload_custom_estimation_update',
  },
  APP_MODES: {
    BASE: 'base',
    EXPORT: 'export',
    PUBLIC_LINK: 'publicLink',
    HISTORY: 'history',
  },
  PAYMENT_STATUSES: {
    ORDER_CHARGED: {
      CODE: 1,
      TEXT: 'OrderCharged',
    },
    ORDER_REFUNDED: {
      CODE: 2,
      TEXT: 'OrderRefunded',
    },
    ORDER_CHARGED_BACK: {
      CODE: 3,
      TEXT: 'OrderChargedBack',
    },
    ORDER_DECLINED: {
      CODE: 4,
      TEXT: 'OrderDeclined',
    },
    ORDER_PARTIALLY_REFUNDED: {
      CODE: 5,
      TEXT: 'OrderPartiallyRefunded',
    },
    SUBSCRIPTION_CHARGE_SUCCEED: {
      CODE: 6,
      TEXT: 'SubscriptionChargeSucceed',
    },
    SUBSCRIPTION_CHARGE_FAILED: {
      CODE: 7,
      TEXT: 'SubscriptionChargeFailed',
    },
    SUBSCRIPTION_SUSPENDED: {
      CODE: 8,
      TEXT: 'SubscriptionSuspended',
    },
    SUBSCRIPTION_RENEWED: {
      CODE: 9,
      TEXT: 'SubscriptionRenewed',
    },
    SUBSCRIPTION_TERMINATED: {
      CODE: 10,
      TEXT: 'SubscriptionTerminated',
    },
    SUBSCRIPTION_FINISHED: {
      CODE: 11,
      TEXT: 'SubscriptionFinished',
    },
    ORDER_PROCESSING: {
      CODE: 110,
      TEXT: 'OrderProcessing',
    },
    TRIAL_ACTIVE: {
      CODE: 8,
      TEXT: 'TrialActive',
    },
  },
  PROGRESS_TYPES: {
    AVERAGE: 'average',
    DURATION: 'duration',
  },
  MAX_USER_COUNT_TO_INVITE_WITHOUT_SALE: 40,
};

export default innerObject;
